<template>
  <a-card :bordered="false" class="filter-card">
    <a-form layout="vertical">
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :sm="8">
          <a-form-item label="크롤링 소스">
            <a-select v-model:value="localSelectedSource" style="width: 100%" placeholder="전체">
              <a-select-option value="">전체</a-select-option>
              <a-select-option v-for="source in sources" :key="source" :value="source">{{ source }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item label="지역">
            <a-select v-model:value="localSelectedCity" style="width: 100%" placeholder="전체">
              <a-select-option value="">전체</a-select-option>
              <a-select-option v-for="city in cities" :key="city" :value="city">{{ city }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="8">
          <a-form-item label="치료 항목">
            <a-select v-model:value="localSelectedTreatment" style="width: 100%" placeholder="전체">
              <a-select-option value="">전체</a-select-option>
              <a-select-option v-for="treatment in treatments" :key="treatment.id" :value="treatment.id">
                {{ treatment.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-item label="검색어">
            <a-input-group compact>
              <a-input
                v-model:value="localSearchKeyword"
                placeholder="병원명, 주소 등을 입력하세요"
                @keyup.enter="applyFilters"
                style="width: calc(100% - 160px)"
              />
              <a-button type="primary" @click="applyFilters">검색</a-button>
              <a-button @click="resetFilters">초기화</a-button>
            </a-input-group>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
export default {
  name: 'hosCrawlFilter',
  props: {
    selectedSource: {
      type: String,
      default: ''
    },
    selectedCity: {
      type: String,
      default: ''
    },
    selectedTreatment: {
      type: [Number, String],
      default: ''
    },
    searchKeyword: {
      type: String,
      default: ''
    }
  },
  emits: ['update:selectedSource', 'update:selectedCity', 'update:selectedTreatment', 'update:searchKeyword', 'apply-filters', 'reset-filters'],
  data() {
    return {
      localSelectedSource: this.selectedSource,
      localSelectedCity: this.selectedCity,
      localSelectedTreatment: this.selectedTreatment,
      localSearchKeyword: this.searchKeyword,
      
      // 필터 옵션들 (API에서 가져올 수도 있음)
      sources: ['modoodoc'],
      cities: ['서울', '경기도', '인천', '부산', '대구', '대전', '광주', '울산', '세종'],
      treatments: [
        { id: 10, name: '임플란트(단일)' },
        { id: 11, name: '임플란트(전체)' },
        { id: 16, name: '클리피씨교정' },
        { id: 4, name: '크라운' },
        { id: 1, name: '치과 스케일링' },
        { id: 22, name: '라미네이트' },
        { id: 85, name: '점/사마귀/쥐젖/비립종' }
      ]
    };
  },
  watch: {
    // props 변경 시 로컬 상태 업데이트
    selectedSource(val) {
      this.localSelectedSource = val;
    },
    selectedCity(val) {
      this.localSelectedCity = val;
    },
    selectedTreatment(val) {
      this.localSelectedTreatment = val;
    },
    searchKeyword(val) {
      this.localSearchKeyword = val;
    },
    
    // 로컬 상태 변경 시 이벤트 발생
    localSelectedSource(val) {
      this.$emit('update:selectedSource', val);
    },
    localSelectedCity(val) {
      this.$emit('update:selectedCity', val);
    },
    localSelectedTreatment(val) {
      this.$emit('update:selectedTreatment', val);
    },
    localSearchKeyword(val) {
      this.$emit('update:searchKeyword', val);
    }
  },
  methods: {
    applyFilters() {
      this.$emit('apply-filters');
    },
    resetFilters() {
      this.localSelectedSource = '';
      this.localSelectedCity = '';
      this.localSelectedTreatment = '';
      this.localSearchKeyword = '';
      this.$emit('reset-filters');
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
</style>
